// Helper class that helps with tracking value changes.
abstract class Tracked<T extends Record<string, unknown>> {
  tracked: T;

  constructor(tracked: T) {
    // Should the proxy be a "revocable" type?
    this.tracked = new Proxy(tracked, {
      get: this.handlePropAccess,
      set: this.handlePropChange,
    } as any);
  }

  handlePropAccess = (
    _target: T,
    prop: keyof T,
    _receiver: any
  ): T[keyof T] => {
    this.willBeAccessed(prop);

    const val = this.onAccess(prop, _target[prop], _target);

    this.wasAccessed(prop);

    return val;
  };

  handlePropChange = (
    target: T,
    prop: keyof T,
    value: any,
    _receiver: any
  ): boolean => {
    if (this.shouldUpdate(prop, value)) {
      this.willUpdate(prop, value);
      const prevValue = target[prop];
      target[prop] = value;
      this.didUpdate(prop, prevValue);
    }

    return true;
  };

  // Lifecycle methods
  shouldUpdate(_prop: keyof T, _value: any): boolean {
    return true;
  }

  willBeAccessed(_prop: keyof T): void {
    // left empty.
  }

  onAccess(_prop: keyof T, val: any, target: T): T[keyof T] {
    return val;
  }

  wasAccessed(_prop: keyof T): void {
    // left empty.
  }

  willUpdate(_prop: keyof T, _nextValue: any): void {
    // left empty.
  }

  didUpdate(_prop: keyof T, _prevValue: any): void {
    // left empty.
  }
}

export default Tracked;
